/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import CKEditorCloudServicesError from '../ckeditorcloudserviceserror';

export default class ServiceNotConnectedError extends CKEditorCloudServicesError {
	public constructor( serviceName: string, context?: unknown ) {
		const message: string = `${ serviceName } Service is not connected.`;

		super( message, context );
	}
}
